import { createReducer, on } from '@ngrx/store';
import { inventoryByPlantResponse } from 'src/app/pages/orders/order-taking/components/new-order/models/iExtraProductFilters';
import {
  clearInventoryByPlantByKey,
  loadInventoryByPlant,
  loadInventoryByPlantFailure,
  loadInventoryByPlantSuccess,
} from './inventory-by-plant.actions';

export interface InventoryByPlantState {
  cache: { [key: string]: inventoryByPlantResponse[] };
  loading: { [key: string]: boolean };
  error: { [key: string]: any };
}

export const initialState: InventoryByPlantState = {
  cache: {},
  loading: {},
  error: {},
};

export const inventoryByPlantReducer = createReducer(
  initialState,
  on(loadInventoryByPlant, (state, { key }) => ({
    ...state,
    loading: { ...state.loading, [key]: true },
    error: { ...state.error, [key]: null },
  })),
  on(loadInventoryByPlantSuccess, (state, { key, data }) => ({
    ...state,
    cache: { ...state.cache, [key]: data ?? [] },
    loading: { ...state.loading, [key]: false },
    error: { ...state.error, [key]: null },
  })),
  on(loadInventoryByPlantFailure, (state, { key, error }) => ({
    ...state,
    loading: { ...state.loading, [key]: false },
    error: { ...state.error, [key]: error },
  })),
  on(clearInventoryByPlantByKey, (state, { key }) => {
    const { [key]: _, ...restCache } = state.cache;
    const { [key]: __, ...restLoading } = state.loading;
    const { [key]: ___, ...restError } = state.error;
    return {
      ...state,
      cache: restCache,
      loading: restLoading,
      error: restError,
    };
  }),
);
